import { render, staticRenderFns } from "./SubscriptionResourcesRecalculationModal.vue?vue&type=template&id=0778eec4&scoped=true&"
import script from "./SubscriptionResourcesRecalculationModal.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionResourcesRecalculationModal.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionResourcesRecalculationModal.vue?vue&type=style&index=0&id=0778eec4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0778eec4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0778eec4')) {
      api.createRecord('0778eec4', component.options)
    } else {
      api.reload('0778eec4', component.options)
    }
    module.hot.accept("./SubscriptionResourcesRecalculationModal.vue?vue&type=template&id=0778eec4&scoped=true&", function () {
      api.rerender('0778eec4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/SubscriptionResourcesRecalculationModal.vue"
export default component.exports